import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { useIntl } from 'react-intl';

import UploadsListHeader from './ListHeader';
import UploadsListItem from './ListItem';

const UploadsList = ({
  uploads,
  loadUploads,
  ...props
}) => {
  const intl = useIntl();

  return (
    <Fragment>
      {uploads.length > 0 ? (
        <div className="table-wrapper">
          <Table className="users-list uploads-list files-list" responsive>
            <thead>
              <UploadsListHeader
                {...props}
              />
            </thead>
            <tbody>
              {uploads.map(upload => (
                <UploadsListItem
                  key={upload.uuid}
                  upload={upload}
                  loadUploads={loadUploads}
                />
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        <div className="nothing-found-wrapper bottom">
          <h3>{intl.formatMessage({ defaultMessage: 'No uploads found' })}</h3>
        </div>
      )}
    </Fragment>
  );
};

UploadsList.propTypes = {
  uploads: PropTypes.array.isRequired,
  loadUploads: PropTypes.func.isRequired,
};

export default UploadsList;
